import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const credit = createAsyncThunk(
  "credit/fetch",
  async (_, { rejectWithValue, serializeError }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/getAllCredits`);
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const creditSlice = createSlice({
  name: "credit",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(credit.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(credit.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(credit.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default creditSlice.reducer;
